import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import styles from "./ImpersonationBar.module.css";

// Persistent admin banner shown for the whole session while impersonating another user.
// Sits at the bottom of every page; the Stop button restores the admin's own token.
const ImpersonationBar = () => {
  const { isImpersonating, user, stopImpersonating } = useContext(AuthContext);
  if (!isImpersonating) return null;
  return (
    <div className={styles.bar} role="status">
      <span className={styles.label}>
        <span className={styles.dot} />
        Impersonating <strong>{user?.playerName ?? user?.steamID ?? "?"}</strong>
      </span>
      <button className={styles.stop} onClick={stopImpersonating}>Stop</button>
    </div>
  );
};

export default ImpersonationBar;
